import { getCookie, deleteCookie } from "../api/auth";

// export const getAuthToken = () => {
//     const authToken = localStorage.getItem("access_token"); // Retrieve the token
//     return authToken;
// };

export const logout = () => {
    // localStorage.removeItem("access_token");
    localStorage.clear();
    sessionStorage.clear();
    deleteCookie('access_token');
    deleteCookie('user_id');
    window.location.href = "/login";
  };
  

  export const getUserDetails = () =>{
    const userDetails = localStorage.getItem("userDetails");
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails
}

export const getUserId = () =>{
  return getCookie('user_id');
}

export const getProfileImage = () => {
  const userDetails = localStorage.getItem("userDetails");
  if (userDetails) {
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails.profile_image ? parsedDetails.profile_image : "uploads/user/user-profile.png";
  }
  return "uploads/user/user-profile.png"; // Default image if no user details exist
};


export const getUserFullName = () =>{
  const userDetails = localStorage.getItem("userDetails");
  if(userDetails){
    
    const parsedDetails = JSON.parse(userDetails);
    const firstName = parsedDetails.first_name || "";
      const lastName = parsedDetails.last_name || "";
      const fullName = `${firstName} ${lastName}`.trim();
      return fullName || null;
  }else{
    console.error("no details found")
  }
}

export const getUsergender = () => {
  const userDetails = localStorage.getItem("userDetails");
  if(userDetails){
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails.gender || null;
  }
};

export const getUserEmail = () =>{
  const userDetails = localStorage.getItem("userDetails");
  if(userDetails){
    
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails.email || null;
  }else{
    console.error("no details found")
  }
}

export const getUserName = () =>{
  const userDetails = localStorage.getItem("userDetails");
  if(userDetails){
    
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails.username || null;
  }else{
    console.error("no details found")
  }
}

export const getUserAddress = () =>{
    const userDetails = localStorage.getItem("userDetails");
    if(userDetails){
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails.address;
    }else{
      return [];
    }
  }

  // export const getAccesstoken = () =>
  //   {
  //     const access_token = localStorage.getItem("access_token");
  //     if(access_token){
  //       return access_token;
  //     }else{
  //       return false;
  //     }
  //   }
  
  export const getAccesstoken = () => {
    return getCookie('access_token');
  };
    